/* eslint-disable   */
import React from "react";

export default function header() {
  return (
    <div>
      <h1 style={head}>Gerador de santinho</h1>
    </div>
  );
}

const head = {
  textAlign: "center",
  color: "white",
};
